import axios from 'axios';
import { apiBaseUrl } from './common';
// Create an Axios instance
const apiClient = axios.create({
  baseURL: apiBaseUrl, // Replace with your API's base URL
});

// Add a request interceptor
apiClient.interceptors.request.use(
  (config) => {
    // Get the token from localStorage
    const token = localStorage.getItem('token'); // Replace with your token's key name
    const jtoken = localStorage.getItem('jtoken'); // Replace with your token's key name

    if (token && jtoken) {
      // Add the token to the Authorization header
      config.headers['Authorization'] = `Bearer ${jtoken}`;
      config.headers['x-auth-token'] = `${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

apiClient.interceptors.response.use(
  (response) => {
    return response; // Forward the response if everything is fine
  },
  (error) => {
    if (error.response && (error.response.status === 403 || error.response.status === 401)) {
      // Log out the user
      localStorage.removeItem('token');
      localStorage.removeItem('jtoken');
      window.location.href = '/login'; 
    }
    return Promise.reject(error); // Forward the error for further handling
  }
);

export default apiClient;
